import styled from 'styled-components';

import { StyledControlBarButton } from '../control-bar-button.styles';

export const StyledShowTOCSidebarButton = styled(StyledControlBarButton)`
  margin-left: 1em;
  @media all and (max-width: 1200px) {
    margin-left: 20px;
  }
`;
